module.exports = __webpack_public_path__ + "img/assembling-machine-1.18d1a0fc.png";